import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=27edf36e&scoped=true&"
import script from "./PopupView.vue?vue&type=script&lang=js&"
export * from "./PopupView.vue?vue&type=script&lang=js&"
import style0 from "./PopupView.vue?vue&type=style&index=0&id=27edf36e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27edf36e",
  null
  
)

export default component.exports